<template>
    <vx-table-row>
        <vx-table-row-title>
            <div class="flex">
                <vx-badge class="mr-2 font-mono" size="xs" color="slate" data-test="link-id">
                    {{ props.modelValue.id }}
                </vx-badge>
                <div class="line-clamp-none break-all lg:line-clamp-2" data-test="name">
                    {{ props.modelValue.name }}
                </div>
            </div>
        </vx-table-row-title>

        <vx-table-row-item data-test="phone">
            <template v-slot:label> Phone: </template>
            {{ props.modelValue.phone }}
        </vx-table-row-item>

        <vx-table-row-buttons>
            <vx-dropdown placement="right">
                <vx-button type="button" color="muted" outline class="w-[45px]" aria-label="Link actions">
                    <font-awesome-icon widthAuto :icon="faEllipsis" />
                </vx-button>

                <template v-slot:items>
                    <vx-dropdown-item :href="href" data-test="view">
                        View
                        <font-awesome-icon widthAuto :icon="faEye" />
                    </vx-dropdown-item>
                    <vx-dropdown-item @click="destroy" data-test="delete">
                        Delete
                        <font-awesome-icon widthAuto :icon="faTrash" />
                    </vx-dropdown-item>
                </template>
            </vx-dropdown>

            <vx-button :href="`${href}/edit`" color="muted" outline data-test="edit">
                Edit <font-awesome-icon widthAuto :icon="faFilePen" />
            </vx-button>
        </vx-table-row-buttons>
    </vx-table-row>
</template>

<script lang="ts" setup>
import { faEllipsis, faEye, faFilePen, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import {
    VxBadge,
    VxButton,
    VxDropdown,
    VxDropdownItem,
    VxSwal,
    VxTableRow,
    VxTableRowButtons,
    VxTableRowItem,
    VxTableRowTitle,
} from '@voxie/frontend-components';
import { computed } from 'vue';
import { adminInboundTextClient } from '~/services';
import type { InboundTextLink } from '~/services/adminInboundTextClient.types';
import { throwSwalRequestError } from '~/utils/request';

const props = defineProps<{
    modelValue: InboundTextLink;
}>();

const emit = defineEmits<{
    deleted: [];
}>();

const href = computed(() => `/kiosk/inbound-text/links/${props.modelValue.id}`);

const destroy = () =>
    VxSwal.confirmation('Delete Link', 'Are you sure? There is no undo.', 'danger', () =>
        adminInboundTextClient
            .deleteLink(props.modelValue.id)
            .then(() => emit('deleted'))
            .catch(throwSwalRequestError)
    );
</script>
